export class KYMW0907OutputModel {
  // 1物N価詳細情報ID
  public nvalDetailId = '';

  // 受注コード
  public orderCode = '';

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードのリスト
  public itemCodeList = [];

  // 媒体
  public mediumType = '';

  // 媒体名
  public mediumName = '';

  // 注文コード割当
  public nvalOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public nvalOrderNumQuotaCodeList = [];

  // 1物N価詳細区分
  public nvalDetailDev = '';

  // 1物N価詳細区分リスト
  public nvalDetailDevList = [];

  // 商品企画担当区分
  public shkkktantKb = '';

  // 専用商品名
  public nvalPromotionGoodsName = '';

  // 専用商品名(カナ)
  public nvalPromotionGoodsNameKana = '';

  // 専用規格名
  public nvalPromotionStandardName = '';

  // 専用規格名(カナ)
  public nvalPromotionStandardNameKana = '';

  // 注文コード
  public orderNum = '';

  // 値引区分
  public discountType = '0';

  // 値引率
  public discountRate = '';
  
  // 値引単価
  public discountUnitPrice = '';

  // 供給単価
  public supplyPriceStandard = '';

  // 値引後供給単価
  public discountSupplyUnitPrice = '';

  // 価格パターン
  public pricePattern = '';

  // 利用都県:全生協
  public allCoop = '';

  // 利用都県:い
  public usePrefecture1Flg = '';

  // 利用都県:と
  public usePrefecture2Flg = '';

  // 利用都県:ぐ
  public usePrefecture3Flg = '';

  // 利用都県:ち
  public usePrefecture4Flg = '';

  // 利用都県:さ
  public usePrefecture5Flg = '';

  // 利用都県:とう
  public usePrefecture6Flg = '';

  // 利用都県:な
  public usePrefecture7Flg = '';

  // 利用都県:に
  public usePrefecture8Flg = '';

  // 備考
  public remarks = '';

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';
}
